<template>
    <v-row>
        <v-col v-for="admin in admins" :key="admin.id" cols="12" class="">
            <v-card flat align="center" class="card dt-border">
                <v-row align="center" >
                    <v-col cols="12" class="card__column" md="4 " style="">
                        <div class="card__column__img" >
                            <img
                            
                            :src="admin.profile.profilepicture" alt="image"
                            />
                        </div>
                        <span>{{admin.profile.firstname + ' ' + admin.profile.lastname}}</span>
                    </v-col>
                    <v-col  cols="12" md="4">
                        <span>{{admin.email}}</span>
                    </v-col>
                    <!-- <v-col  cols="12" md="4">
                        <v-btn dark color="red" depressed style="float:right;font-size:12px">
                            Suspend
                        </v-btn>
                    </v-col> -->
                    <v-col md="2">
                        <v-icon v-if="admin.status == active" color="green">
                            mdi-checkbox-marked-circle
                        </v-icon>
                        <v-icon v-if="admin.status == inactive" color="red">
                            mdi-close-circle
                        </v-icon>
                    </v-col>
                    <v-col md="2">
                        <v-menu :disabled="!can('can_manage_admins')" :close-on-content-click="true" bottom right>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" icon>
                                    <v-icon>
                                        mdi-dots-vertical
                                    </v-icon>
                                </v-btn>
                            </template>

                            <v-list>
                                <v-list-item v-if="can('can_manage_admins')" link> 
                                     <v-list-item-title v-if="admin.status == active" color="red"  >
                                        <Adminsuspension-modal @closeModal="closeModal" :details="admin" />
                                    </v-list-item-title>
                                    
                                    <v-list-item-title v-if="admin.status == inactive" ><v-list-item v-if="can('can_manage_admins')" link>
                                        <v-list-item-title>
                                            <Adminactivation-modal @closeModal="closeModal" :details="admin" />
                                        </v-list-item-title>
                                    </v-list-item>
                                    </v-list-item-title> 
                                </v-list-item>
                                <v-list-item-title>
                                    <v-list-item v-if="can('can_manage_admins')" link>
                                        <v-list-item-title>
                                            <admin-reset-pin-modal @closeModal="closeModal" :details="admin" />
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list-item-title> 

                                <v-list-item-title>
                                    <v-list-item v-if="can('can_manage_admins')" link>
                                        <v-list-item-title>
                                            <Deleteadmin-modal @closeModal="closeModal" :details="admin" />
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list-item-title>

                                <v-list-item link>
                                    <v-list-item-title>
                                        <editpermissions-modal @closeModal = "closeModal" :details = "admin" />
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                            
                        </v-menu> 
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
// ============ IMPORT COMPONENTS ============
import EditpermissionsModal from './edit-permission-modal.vue'
import AdminsuspensionModal from './admin-suspension-modal.vue'
import AdminactivationModal from './admin-activation-modal.vue'
import DeleteadminModal from './delete-admin-modal.vue'
import adminResetPinModal from './admin-reset-pin-modal .vue'



// ============== IMPORT SERVICES ===============
import { StatusType } from "@/enums";
import { StoresService } from "@/services";

export default {
    props:{
        admins:{
            type:Array,
        }
    },
    components:{
        EditpermissionsModal,
        AdminsuspensionModal,
        AdminactivationModal,
        DeleteadminModal,
        adminResetPinModal
    },
    data : () => ({
        active : StatusType.ACTIVE,
        inactive : StatusType.INACTIVE
    }),
    mounted(){
    },
    methods: {
        async suspendAdmin(index, status) {
            this.loading = true;
            try {
                const data = await StoresService.suspendAdmin({
                    id: index.id,
                    status: status
                });
                this.loading = false;
                if (status == this.active) {
                    this.$store.dispatch('toast', {
                        message: `${index.name} Admin has been activated`,
                        variant: 'success'
                    })
                }
                if (status == this.inactive) {
                    this.$store.dispatch('toast', {
                        message: `${index.name} Admin has been deactivated`,
                        variant: 'success'
                    })
                }
                console.log(data);
                this.$emit('reload');
            } catch (error) {
                this.loading = false
                console.log(error);
            }
        },
        async closeModal(){
            this.$emit('reload');
        },
    }
}
</script>

<style lang="scss" scoped>
// @import '';
@import './styles.scss'


</style>